import React, { useState } from "react";
import { Box, Button, IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { FileModel } from "../models/models";
import CameraIcon from "../assets/icons/CameraIcon";
import UploadImageCrop from "./UploadImageCrop";
import { dt } from "../themes/redesignTokens";

interface UploadFileProps {
  file?: FileModel | null;
  maxFileSizeMb?: number;
  width?: string;
  height?: string;
  deleteButtonTitle?: string;
  onChangeFile?: (file: FileModel | null) => void;
  cropVariant?: "circle" | "square" | "rectangle";
  minCropWidth: number;
  modalWidth: string;
  aspectRatio: number;
}

const UploadImage = ({
  file,
  maxFileSizeMb = 5,
  width = "120px",
  height = "120px",
  deleteButtonTitle = "Delete",
  cropVariant,
  minCropWidth,
  modalWidth,
  aspectRatio,
  onChangeFile
}: UploadFileProps) => {

  const [isUploadImageResizeAndCrop, setIsUploadImageResizeAndCrop] = useState(false);

  const isCircleImage = cropVariant === "circle";

  const handleFileDelete = () => {
    onChangeFile?.(null);
  };

  return (
    <Box className="flex flex-col">
      <Box
        className="upload-image relative"
        sx={{ borderRadius: isCircleImage ? "50%" : "8px", background: isCircleImage ? "#d0d0d0" : "" }}
      >
        <label onClick={() => setIsUploadImageResizeAndCrop(true)}>
          {file?.content ? (
            <Box className="cursor-pointer">
              <img
                className="object-cover"
                style={{ width: width, height: height, aspectRatio: aspectRatio, borderRadius: isCircleImage ? "50%" : "7px" }}
                src={file.content}
                alt=""
              />
            </Box>
          ) : (
            <Box
              className="flex items-center justify-center cursor-pointer"
              sx={{ width: width, height: height, aspectRatio: aspectRatio }}
            >
              <CameraIcon />
            </Box>
          )}

          <Box className="absolute" sx={{ bottom: isCircleImage ? 0 : "8px", right: isCircleImage ? 0 : "8px" }}>
            <IconButton component="span" disableRipple sx={{ background: "#FFFFFF" }}>
              <EditOutlinedIcon sx={{ color: dt.blue }}></EditOutlinedIcon>
            </IconButton>
          </Box>
        </label>
      </Box>

      {file?.content && (
        <Box className="flex justify-center">
          <Button variant="text" onClick={handleFileDelete}>
            {deleteButtonTitle}
          </Button>
        </Box>
      )}

      <UploadImageCrop
        open={isUploadImageResizeAndCrop}
        onClose={() => {
          setIsUploadImageResizeAndCrop(false);
        }}
        file={file}
        onChangeFile={onChangeFile}
        cropVariant={cropVariant}
        maxFileSizeMb={maxFileSizeMb}
        minCropWidth={minCropWidth}
        modalWidth={modalWidth}
        aspectRatio={aspectRatio}
      />
    </Box>
  );
};
export default UploadImage;